import React, { useState, useEffect } from 'react'

const ViewSelect = props => {

  const { views, userviews, handleViewChange, userEdit, bRole, customerId } = props;

  const [viewsToDisplay, setViewsToDisplay] = useState([]);

  useEffect(() => {
    if(views && views.length > 0){
      let tempViews = [...views];

      // unless we are role of master admin we should only be able to view site access for the customer to which our user is assigned
      if(bRole !== 1 && customerId !== 'none'){
        tempViews = tempViews.filter(v => v.bCustomerID === parseInt(customerId));
      };

      setViewsToDisplay(tempViews);
    };
  }, [views, bRole, customerId]);

  return (
    <div style={{ width: '50%', paddingRight: '2vmin', paddingLeft: '2vmin' }}>
      <p style={{ marginTop: '1vmin', marginBottom: '1vmin', fontSize: '1.4vmin', fontWeight: 'bold', textDecoration: "underline" }}>{`View Access (cloud NVR)`}</p>

      <div style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <div style={{ textAlign: 'left', marginRight: '2vmin' }}>


          {viewsToDisplay && viewsToDisplay.length > 0 &&
              viewsToDisplay.slice(0,9).map(v => (
                <div key={v.bID} style={{ display: "flex", alignItems: 'center', marginBottom: '.5vmin' }}>
                  <input
                    type="checkbox"
                    id={v.bID}
                    name={v.sName}
                    value={v.bID}
                    checked={userviews.includes(v.bID)}
                    style={{ cursor: 'pointer', height: userEdit ? '1.4vmin' : '1.6vmin', width: userEdit ? '1.4vmin' : '1.6vmin' }}
                    onChange={e => handleViewChange(e)}/>
                  <span style={{ marginLeft: '1vmin', fontSize: userEdit ? '1.4vmin' : '1.6vmin' }}>{v.sName}</span>
                </div>
              ))
          }
        </div>
      </div>
    </div>
  )
}

export default ViewSelect;